import { evaluateArithmetic } from '../lib/evaluateArithmetic.js';

const CalculatorOverlay = ({ calculatorState, setCalculatorState }) => {
  if (!calculatorState.isOpen) return null;

  const handleInput = (char) => {
    let newVal = calculatorState.value + char;
    setCalculatorState({ ...calculatorState, value: newVal });
    try {
      if (/^[\d\.\+\-\*\/\(\)]+$/.test(newVal) && /[\d\)]$/.test(newVal)) {
        const evaled = evaluateArithmetic(newVal);
        if (calculatorState.onUpdate && !isNaN(evaled)) {
          calculatorState.onUpdate(evaled);
        }
      }
    } catch(e) {}
  };

  const handleAC = () => {
    setCalculatorState({ ...calculatorState, value: '' });
    if (calculatorState.onUpdate) calculatorState.onUpdate(0);
  };

  const handleDelete = () => {
    let newVal = String(calculatorState.value).slice(0, -1);
    setCalculatorState({ ...calculatorState, value: newVal });
    try {
      if (/^[\d\.\+\-\*\/\(\)]+$/.test(newVal) && /[\d\)]$/.test(newVal)) {
        const evaled = evaluateArithmetic(newVal);
        if (calculatorState.onUpdate && !isNaN(evaled)) calculatorState.onUpdate(evaled);
      } else if (newVal === '') {
        if (calculatorState.onUpdate) calculatorState.onUpdate(0);
      }
    } catch(e) {}
  };

  const handleEqual = () => {
    try {
      if (/^[\d\.\+\-\*\/\(\)]+$/.test(calculatorState.value)) {
        const evaled = evaluateArithmetic(calculatorState.value);
        if (!isNaN(evaled)) {
          setCalculatorState({ ...calculatorState, value: String(evaled) });
          if (calculatorState.onUpdate) calculatorState.onUpdate(evaled);
        }
      }
    } catch(e) {}
  };

  const closeCalc = () => {
    setCalculatorState({ ...calculatorState, isOpen: false });
  };

  const isDesktop = typeof window !== 'undefined' && window.innerWidth > 768;
  return (
    <>
      {isDesktop && (
        <div onClick={closeCalc} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 9998 }} />
      )}
      <div onClick={(e) => e.stopPropagation()} style={{
        position: 'fixed',
        ...(isDesktop
          ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '320px', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }
          : { bottom: 0, left: 0, right: 0, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }
        ),
        background: 'var(--bg-primary)',
        border: '1px solid var(--border-color)',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
        zIndex: 9999,
        padding: '20px',
      }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h4 style={{ margin: 0, color: 'var(--brand-success)', fontSize: '1rem', fontWeight: 600 }}>{calculatorState.label || 'Calculator'}</h4>
        <button onClick={closeCalc} style={{ background: 'transparent', border: 'none', fontSize: '1.2rem', cursor: 'pointer', color: 'var(--text-secondary)' }}>✕</button>
      </div>
      
      <div style={{
        background: 'var(--bg-tertiary)',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '16px',
        textAlign: 'right',
        fontSize: '1.5rem',
        fontWeight: 700,
        minHeight: '48px',
        color: 'var(--text-primary)',
        overflowX: 'auto',
        whiteSpace: 'nowrap'
      }}>
        {calculatorState.value || '0'}
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '8px'
      }}>
        <button className='calc-btn op' onClick={handleAC}>AC</button>
        <button className='calc-btn op' onClick={() => handleInput('(')}>(</button>
        <button className='calc-btn op' onClick={() => handleInput(')')}>)</button>
        <button className='calc-btn op' onClick={handleDelete}>⌫</button>

        <button className='calc-btn num' onClick={() => handleInput('7')}>7</button>
        <button className='calc-btn num' onClick={() => handleInput('8')}>8</button>
        <button className='calc-btn num' onClick={() => handleInput('9')}>9</button>
        <button className='calc-btn op' onClick={() => handleInput('/')}>÷</button>

        <button className='calc-btn num' onClick={() => handleInput('4')}>4</button>
        <button className='calc-btn num' onClick={() => handleInput('5')}>5</button>
        <button className='calc-btn num' onClick={() => handleInput('6')}>6</button>
        <button className='calc-btn op' onClick={() => handleInput('*')}>×</button>

        <button className='calc-btn num' onClick={() => handleInput('1')}>1</button>
        <button className='calc-btn num' onClick={() => handleInput('2')}>2</button>
        <button className='calc-btn num' onClick={() => handleInput('3')}>3</button>
        <button className='calc-btn op' onClick={() => handleInput('-')}>-</button>

        <button className='calc-btn num' onClick={() => handleInput('.')}>.</button>
        <button className='calc-btn num' onClick={() => handleInput('0')}>0</button>
        <button className='calc-btn op' onClick={handleEqual}>=</button>
        <button className='calc-btn op' onClick={() => handleInput('+')}>+</button>
      </div>

      <style>{`
        .calc-btn {
          padding: 16px 0;
          font-size: 1.25rem;
          font-weight: 600;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          transition: background 0.1s;
        }
        .calc-btn.num {
          background: var(--bg-secondary);
          color: var(--text-primary);
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }
        .calc-btn.op {
          background: rgba(99,102,241,0.1);
          color: var(--accent-primary);
        }
        .calc-btn:active {
          transform: scale(0.95);
        }
      `}</style>
    </div>
    </>
  );
};

export default CalculatorOverlay;
